/* eslint-disable react/jsx-props-no-spreading */
// import classNames from 'classnames';
// import { FormattedMessage } from 'react-intl';
import { FieldWithForm as FieldWithFormField } from '@micromag/fields';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/fields/custom-font.module.scss';

const removeExtension = (str) => (str !== null ? str.replace(/\.[^.]+$/, '') : str);

const propTypes = {
    value: AppPropTypes.customFont,
    fields: PropTypes.arrayOf(PropTypes.shape({})),
    onChange: PropTypes.func,
    gotoFieldForm: PropTypes.func,
};

const defaultProps = {
    value: null,
    fields: [],
    onChange: null,
    gotoFieldForm: null,
};

const CustomFontField = ({ value, onChange, fields, gotoFieldForm, ...props }) => {
    const onFieldChange = useCallback(
        (newValue) => {
            const { name = null, media = null } = newValue || {};
            const finalNewValue =
                media !== null && isEmpty(name)
                    ? {
                          ...newValue,
                          name: removeExtension(media.name || null),
                      }
                    : newValue;
            if (onChange !== null) {
                onChange(finalNewValue);
            }
        },
        [onChange],
    );

    const finalValue = useMemo(() => {
        const { name = null, media = null } = value || {};
        return media !== null && isEmpty(name)
            ? {
                  ...value,
                  name: removeExtension(media.name || null),
              }
            : value;
    }, []);

    const finalFields = useMemo(
        () =>
            fields.map((field) => {
                if (field.name === 'media') {
                    return {
                        ...field,
                    };
                }
                return field;
            }),
        [fields],
    );

    return (
        <FieldWithFormField
            className={styles.container}
            value={finalValue}
            onChange={onFieldChange}
            fields={finalFields}
            gotoFieldForm={gotoFieldForm}
            {...props}
        />
    );
};

CustomFontField.propTypes = propTypes;
CustomFontField.defaultProps = defaultProps;
CustomFontField.withForm = true;

export default CustomFontField;
